import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAlternateHrefStore = defineStore('alternateHref', () => {
    const links = ref([])

    const setAlternateHref = (alternateLinks) => links.value = alternateLinks;

    function getAlternateHref(lang) {
        const found = links.value.find(link => link.hreflang === lang)
        if (found) {
            const url = new URL(found.href)
            return url.pathname + url.search
        }
        return null
    }

    const clean = () => links.value = [];

    return {
        links,
        clean,
        setAlternateHref,
        getAlternateHref
    }
})
